import { Layout } from '../components/Layout'
import { PrefixLookup } from '../components/PrefixLookup'
import { TrackBox } from '../components/TrackBox'
import { PageMeta } from '../lib/meta'
import { surface } from '../surface'

const MILESTONES: [string, string][] = [
  ['RCS', 'Received from shipper'],
  ['DEP', 'Departed / uplift'],
  ['ARR', 'Arrived at station'],
  ['RCF', 'Received from flight'],
  ['NFD', 'Notified, ready'],
  ['DLV', 'Delivered'],
]

export function AircargoHome() {
  return (
    <Layout onDark>
      <PageMeta />
      {/* ── Deep-ink hero island ─────────────────────────────────────────────── */}
      <div className="tone-dark overflow-x-clip">
        <section className="hero-glow">
          <div className="mx-auto max-w-3xl px-5 pt-14 pb-16 text-center">
            <span className="eyebrow reveal reveal-1 justify-center">
              <span className="live-dot pulse-dot" aria-hidden />
              {surface.eyebrow}
            </span>
            <h1 className="reveal reveal-2 mx-auto mt-5 max-w-2xl text-[clamp(2.1rem,5.2vw,3.3rem)] font-light leading-[1.02] tracking-[-0.03em] text-ink opacity-95">
              Track any <span className="hl">air waybill</span>, live.
            </h1>
            <p className="reveal reveal-3 mx-auto mt-5 max-w-2xl text-[16px] leading-[1.5] text-muted">
              Paste an 11-digit AWB, a 3-digit airline prefix plus its serial, and follow the
              shipment through every IATA Cargo-IMP milestone, origin to destination, across the
              world’s cargo airlines.
            </p>
            <div className="reveal reveal-3 mx-auto mt-8 max-w-2xl text-left">
              <TrackBox />
            </div>
          </div>
        </section>
      </div>

      {/* ── Light content ────────────────────────────────────────────────────── */}
      <section className="mx-auto max-w-5xl px-5 pt-14">
        <div className="grid gap-5 md:grid-cols-[1.4fr_1fr]">
          {/* milestone legend */}
          <div className="card p-6">
            <div className="mono text-[11px] uppercase tracking-[0.18em] text-signal">
              How air moves
            </div>
            <h2 className="mt-1 text-2xl font-light tracking-tight text-ink">
              Six milestones, one timeline
            </h2>
            <p className="mt-2 text-sm text-muted [hyphens:auto] [text-align:justify]">
              Every airline connector is normalised onto the same closed set of Cargo-IMP status
              codes, so an Emirates AWB and a Cebu Pacific AWB read identically.
            </p>
            <div className="mt-5 grid gap-2 sm:grid-cols-2">
              {MILESTONES.map(([code, label], i) => (
                <div
                  key={code}
                  className="flex items-center gap-3 rounded-xl border border-border bg-surface-1/50 px-3 py-2.5"
                >
                  <span className="mono grid h-7 w-9 shrink-0 place-items-center rounded-md bg-signal text-xs font-bold text-on-accent">
                    {code}
                  </span>
                  <span className="text-sm text-ink">{label}</span>
                  <span className="mono ml-auto text-xs text-faint tnum">{i + 1}</span>
                </div>
              ))}
            </div>
          </div>

          <PrefixLookup />
        </div>
      </section>
    </Layout>
  )
}
